import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { WaitingRoomFactory } from '../pages/waiting-room/WaitingRoomFactory';
import { MainLayout } from '../layouts/main/MainLayout';
import { MeetLayout } from '../layouts/meet/MeetLayout';
import { RoomFactory } from '../pages/room/RoomFactory';
import { FeedbackFactory } from '../pages/feedback/FeedbackFactory';
import { FinishPage } from '../pages/finish/Finish';

const router = createBrowserRouter([
	{
		path: '/',
		children: [
			{
				path: '/',
				element: <MainLayout />,
				children: [
					{
						path: '/',
						element: <WaitingRoomFactory />,
					},
					{
						path: '/c/:code',
						element: <WaitingRoomFactory />,
					},
					{
						path: '/c/:code/:lang',
						element: <WaitingRoomFactory />,
					},
					{
						path: '/c/:code/tenant/:tenant',
						element: <WaitingRoomFactory />,
					},

					{
						path: '/c/:code/tenant/:tenant/:lang',
						element: <WaitingRoomFactory />,
					},
					{
						path: '/feedback/c/:code',
						element: <FeedbackFactory />,
					},
					{
						path: '/feedback/c/:code/tenant/:tenant',
						element: <FeedbackFactory />,
					},
					{
						path: '/finish/c/:code',
						element: <FinishPage />,
					},
					{
						path: '/finish/c/:code/tenant/:tenant',
						element: <FinishPage />,
					},

					/* To deprecate*/
					{
						path: '/c//:code',
						element: <WaitingRoomFactory />,
					},
					{
						path: '/c//:code/:lang',
						element: <WaitingRoomFactory />,
					},
					{
						path: '/c//:code/tenant/:tenant',
						element: <WaitingRoomFactory />,
					},

					{
						path: '/c//:code/tenant/:tenant/:lang',
						element: <WaitingRoomFactory />,
					},
				]
			},
			{
				path: '/',
				element: <MeetLayout />,
				children: [
					{
						path: '/room/:code',
						element: <RoomFactory />,
					},
					{
						path: '/room/:code/tenant/:tenant',
						element: <RoomFactory />,
					},
				]
			}
		],
	},
]);

export function Router() {
	return <RouterProvider router={router} />;
}
